export default "<app-navbar></app-navbar>\n\n<router-outlet></router-outlet>"